import React from "react";
import { Location } from "../Location";
import { ContractsPriceTemplateEditor } from "../../config_editor/ContractsPriceTemplates/ContractsPriceTemplateEditor";

interface Params {
  templateId: string;
}

export class ContractsPriceTemplateEditLocation extends Location<Params> {
  constructor(templateId: string) {
    super({ templateId });
  }

  render() {
    const { templateId } = this.params;
    return <ContractsPriceTemplateEditor id={templateId} />;
  }

  toURI() {
    const { templateId } = this.params;
    return `/config_editor/contract_templates/${templateId || "new"} `;
  }
}
